import { abortableFetch, useEventCallback } from '@eas/common-web';
import { createParticipantRequestTarget } from '@composite/participants/participant-create-utils';
import { EsFile, Writer } from '@models';
import { EvidenceApiUrl, ParticipantType } from '@enums';

export function useAddWriterDialog() {
  const callApi = useEventCallback(
    (formData: Writer, esFile: EsFile | undefined) => {
      const requestTarget = createParticipantRequestTarget(
        esFile,
        EvidenceApiUrl.ES_FILES
      );

      return abortableFetch(requestTarget.url, {
        method: 'POST',
        headers: new Headers({
          'Content-Type': 'application/json',
        }),
        body: JSON.stringify({
          ...formData,
          type: ParticipantType.WRITER,
          esFile: requestTarget.esFile,
        }),
      });
    }
  );

  return {
    callApi,
  };
}
